import axios from 'axios';


const API_URL = process.env.REACT_APP_API

const PROXY_URL = process.env.REACT_APP_PROXY_API

const rando = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%ˆ&*()_+{|:?><';
const getRandom = () => {
  var result = '';
  var flowersend = rando.length;
  for (var i = 0; i < 64; i++) {
    result += rando.charAt(Math.floor(Math.random() * flowersend));
  }
  return result;
}

const get_totp = async () => {
  const w01 =  getRandom()
  const w02 = new Date()
  let result = "", latitude = "0", longitude = "0";
  navigator.geolocation.getCurrentPosition((success, error, options) => {
    latitude = success.coords.latitude;
    longitude = success.coords.longitude
  });
  const w03 = latitude + longitude;
  const authorization = "ywiedYBoMNsxugkAtcjerw==:0ocwF6STwYcgSUV12x8deQ=="
  try {

    let response  = await axios.post(PROXY_URL,{
      cache: 'proxycache',
      payload:{
        w01,
        w02,
        w03,
        w04:{
          "function":'XL7FefG',
          authorization,
          request:'XCHF101',
          referer: "https://wirebit.com/*"
        }
      },
    })
    return response.data.payload.r01
  } catch (e) {
    console.log(e);
  }
}



export const get_order = async (token) => {
  try {
    let response  = await axios.post(API_URL + 'webapiv0',{
      payload:{
        w01:'g_ecomms',
        w02:'',
        w03:token,
        w04:{
          "function":"get_ecomm_checkout"
        },
        w05:await get_totp()
      },
    })
    return {...response.data.payload, token}
  } catch (e) {
    console.log(e);
  }
}

export const get_image = async (token) => {
  try {
    let image_response  = await axios.post(API_URL + 'webapiv0/images',{
      payload:{
        w01:'g_general',
        w02:'',
        w03:token,
        w04:{
          function:'download_ecomm_logo',
        },
        w05:await get_totp()
      }
    })
    let { img } = image_response.data.payload
    return image_response.data.payload
  } catch (e) {
    console.log(e);
  }
}

export const get_address = async (state) => {
  let { token, coin, net, email, shipping, internal } = state;
  try {
    let response = await axios.post(API_URL + 'webapiv0',{
      payload:{
        w01:'g_ecomms',
        w02:'',
        w03:token,
        w04:{
          function:'get_payment_address',
          coin, net, email, shipping, internal
        },
        w05:await get_totp()
      }
    })
    return response.data
  } catch (e) {
    console.log(e);
  }
}

export default {
  get_order,
  get_address
}
